export default "__VITE_ASSET__1I4jPXvL__"